import { Injectable } from '@angular/core';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StateDto } from '@cradua/data';
@Injectable({
  providedIn: 'root',
})
export class StateService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}
  // get all state api
  getAllState(): Observable<StateDto[]> {
    return this.http.get<StateDto[]>(this.url + 'state');
  }

  // get single state api
  getSingleState(id: string): Observable<any> {
    return this.http.get(this.url + 'state/' + id);
  }

  // create state api
  createState(data: StateDto[]): Observable<StateDto[]> {
    return this.http.post<StateDto[]>(this.url + 'state', data);
  }

  // update state api
  updateState(data: StateDto[]): Observable<StateDto[]> {
    return this.http.post<StateDto[]>(this.url + 'state/update', data);
  }

  // delete state api
  deleteState(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('state', ids.join(', '));
    return this.http.delete(this.url + 'state', httpOptions);
  }
}
